<template>
<!-- 共通部分、app.vueにv-appとv-containerなどが既にある -->
  <v-content class="top-a" :style="(init.preview == 1) ? 'padding-bottom:70px;' : ''">
    <component :is="'style'" type="text/css" v-if="init.top_background_image">
      .wrap::before {
        background-image: url({{init.top_background_image}}) !important;
        background-size: cover !important;
        content: "";
        display: block;
        position: fixed;
        top: 0;
        left: auto;
        z-index: -1;
        width: 375px;
        height: 100vh;
      }
    </component>
    <div class="wrap" style="min-height:100vh;">
    <!-- logo -->
    <v-row align-content="center" justify="center" no-gutters class="logo" :style="{
        backgroundImage: 'url(' + init.top_background_image + ') !important',
        backgroundSize: 'cover !important',
    }">
      <img v-if="init.top_logo_image" :src="init.top_logo_image" style="width:auto; max-width:100%;" />
      <span v-else style="font-weight: bold; font-size: 22px;">{{init.shop_name}}</span>
    </v-row>

    <!-- background & scroll -->
    <div class="body" :style="init.top_background_color">
      <!-- carousel -->
      <v-row align-content="start" justify="center" no-gutters class="mb-5" v-show="banners && banners.length > 0">
        <v-carousel v-model="model" height="163" :show-arrows="false" cycle :continuous="false" hide-delimiters>

          <div v-for="(item, i) in banners" :key="i">
              <v-carousel-item :key="i" :src="item.image_url" @click.stop="fromBannerTo(item.is_external, item.external_url, item.banner_title, item.banner_id, item.start_browser_flg)"></v-carousel-item>
          </div>
        </v-carousel>
        <v-row justify="center" class="carouselCtrl">
          <v-icon size="6px" v-for="(item, i) in banners" :key="i" @click="model = i" :class="[model == i ? 'active' : '']">{{model == i ? 'mdi-checkbox-blank-circle' : 'mdi-checkbox-blank-circle-outline'}}</v-icon>
        </v-row>
      </v-row>

      <!-- menu list -->
      <v-row align-content="start" justify="center" no-gutters v-for="(item, i) in menus" :key="i">
        <v-card class="card mt-5" outlined :img="item.background_image_url" @click.stop="NextRouting(item.external_url, item.feature_id, item.screen_id, item.transition_type, item.top_type, item.cassette_id, item.transition_info, item.title)">
          <span class="cardTitle" v-if="item.title_view_flg" :style="{color: item.title_color}">{{item.title}}</span>
          <span class="cardDescription" :style="{color: item.sub_title_color}">{{item.sub_title}}</span>
          <v-btn v-if="item.is_more_hidden == 0" rounded elevation="0" small class="cardButton maincolor-bg" :style="{color: item.more_button_color + ' !important'}" @click.stop="NextRouting(item.external_url, item.feature_id, item.screen_id, item.transition_type, item.top_type, item.cassette_id, item.transition_info, item.title)">
            MORE
          </v-btn>
        </v-card>
      </v-row>

      <noticeDialogue ref="noticeDialogue" :item="one_time_notice"></noticeDialogue>
    </div>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
    <GlobalFooter v-if="init.preview == 1" :menus="init.menu_data" />

  </v-content>
</template>

<script>

import noticeDialogue from "@/components/notice_dialog.vue"
import GlobalFooter from "@/components/global_footer.vue"
export default {
  components: {
      noticeDialogue,
      GlobalFooter
  },
  data () {
    return {
      init: [],
      model: 0,
      banners: [],
      menus: [],
      one_time_notice: [],
      badgeParams: {},
      // NEW_DEV-1831 cyber start
      isStartUp: null,
      one_time_notice_list: [],
      // NEW_DEV-1831 cyber end
      loading: false,
    }
  },
  async created () {
    //createdで、localstrageから全ての保存情報を取得しinitに格納
    this.init = this.storageGet('*')

    try{
      var banners_req = { params:{
        'sid': this.init.sid,
        'service_cd': this.init.service_cd,
        'device_uid': this.init.device_uid,
        'device_id': this.init.device_id,
        'os': this.init.os,
        'key': this.init.key,
        'preview': this.$route.query.preview, //isPreview Getパラメータがある場合は、APIにisPreviewを渡す
        //NEW_DEV-2220 cyber start
        'regist_layout_flg': this.getUrlGetParam('registLayoutFlg')
        //NEW_DEV-2220 cyber end
      }}
      var res = await this.apiCall('/user/banners', banners_req, 'get');
      if (!res) return false;
      this.$set(this, 'banners', res.banners);

      var menus_req = { params:{
        'sid': this.init.sid,
        'service_cd': this.init.service_cd,
        'device_uid': this.init.device_uid,
        'device_id': this.init.device_id,
        'os': this.init.os,
        'key': this.init.key,
        'preview': this.$route.query.preview, //isPreview Getパラメータがある場合は、APIにisPreviewを渡す
        // NEW_DEV-1856 cyber start
        'login_id':this.init.login_id,
        //NEW_DEV-2220 cyber start
        'regist_layout_flg': this.getUrlGetParam('registLayoutFlg')
        //NEW_DEV-2220 cyber end
      }}
      var menu_res = await this.apiCall('/user/topmenu/1', menus_req, 'get');
      if (!menu_res) return false;
      var point_res = await this.apiCall('point', menus_req);
      if (!point_res) return false;
      // NEW_DEV-1856 cyber end
      this.$set(this, 'menus', menu_res.menus);
      // NEW_DEV-1831 cyber start
      window.getIsStartUp = this.getIsStartUp;
      let params = {
          '_vue_param': true,
          'top_display': true,
      };
      // NEW_DEV-2220 cyber start
      if(this.$route.query.preview != 1){
        alert(JSON.stringify(params));
      }
      // NEW_DEV-2220 cyber end
      this.one_time_notice_list = menu_res.one_time_notice_list;
      // NEW_DEV-1831 cyber end
    } catch(e) {
      this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  watch: { //init apiが読み込まれたか監視
    '$root.init_flg': 'fetchData',
    // NEW_DEV-1831 cyber start
    isStartUp: function() {
      let userId = 'userId' + this.init.user_id;
      let objtoken = null;
      if(this.one_time_notice_list != null && this.isStartUp == 1){
        let top_one_time_notice_ids = this.storageGet('top_one_time_notice_ids');
        if(top_one_time_notice_ids && top_one_time_notice_ids.length != 0){
          let ids = top_one_time_notice_ids[userId];
          for (const elem of this.one_time_notice_list) {
            if (!this.inArray(elem.id, ids)) {
              this.$set(this, 'one_time_notice', elem);
              ids.push(elem.id);
              top_one_time_notice_ids[userId] = ids;
              objtoken = (JSON.stringify({
                            'top_one_time_notice_ids': top_one_time_notice_ids
                          }))
              this.storageSave(objtoken)
              this.$refs.noticeDialogue.open();
              break;
            }
          }
        }else{
          let res = this.one_time_notice_list[0];
          this.$set(this, 'one_time_notice', res);
          let ids = new Array();
          ids.push(res.id);
          let new_top_one_time_notice_ids = {};
          new_top_one_time_notice_ids[userId] = ids;
          objtoken = (JSON.stringify({
                        'top_one_time_notice_ids': new_top_one_time_notice_ids
                      }))
          this.storageSave(objtoken)
          this.$refs.noticeDialogue.open();
        }
      }
    },
    // NEW_DEV-1831 cyber end
  },
  methods: {
    fetchData(){ //init apiが読み込まれた場合initに値を入れる
        this.init = this.storageGet('*')

        //バッジ数をネイティブに送る
        this.badgeParams['_vue_param'] = true;
        this.badgeParams['menu_data'] = this.init.menu_data;
        this.badgeParams['total_unread_count'] = this.init.total_unread_count;
        //console.log(this.badgeParams)
        this.nativePost(this.badgeParams);
    },
    async NextRouting(destination, feature_id, screen_id, transition_type, top_type, cassette_id, transition_info, page_title){
      try{
        // プレビューの場合は通常遷移させる
        if (this.$route.query.preview) {
          return window.location.href = destination + '?sid=' + this.init.sid + '&preview=1';
        }
        
        // 多重処理防止
        if (this.loading) return
        this.loading = true

        //タップAPI
        var tap_req = {
          'sid': this.init.sid,
          'service_cd': this.init.service_cd,
          'device_uid': this.init.device_uid,
          'device_id': this.init.device_id,
          'os': this.init.os,
          'key': this.init.key,
          'top_type': top_type,
          'cassette_id': cassette_id,
          'transition_type': transition_type,
          'transition_info': transition_info,
        }
        var tap_res = await this.apiCall('/user/tap', tap_req, 'post');
        if (!tap_res) { return false }

        if(feature_id == null){
          feature_id = 0
        }
        var tonative_req = {
          'destination': destination,
          'feature_id': feature_id,
          'screen_id': screen_id,
          'transition_type': transition_type,
          'page_title': page_title,
          'cassette_id': cassette_id,
          'top_type': top_type,
        };
        console.log(tonative_req);
        var business_service_req = {params: {
            'sid': this.storageGet('sid')
          }}
        var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)
        if (!business_service_res.data) return false;
        if (destination.indexOf('mop') != -1) {          
          const moplink = "https://" + process.env.VUE_APP_HOST_NAME + "/mop/shop-list?sid="+this.init.sid+"&os="+this.init.os+"&device_id="+this.init.device_id+"&key="+this.init.key+"&registration_id="+this.init.registration_id+"&app_version="+this.init.app_version+"&feature_id=1&device_uid="+this.init.device_uid+"&business_code="+business_service_res.data.business_code;
          location.replace(moplink);
          return;
        }
        if (!(this.screenTransition(tonative_req))) {
          // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }

      } catch(e) {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー解除
        this.loading = false
      }
    },
    fromBannerTo(is_external, external_url, page_title, banner_id, start_browser_flg){
      this.loading = true;

      if(is_external == 1){
        var transition_type = 2
        if(start_browser_flg == 1){
          transition_type = 4
        }

        var tonative_req = {
          'destination': external_url,
          'feature_id': 0,
          'screen_id': 'banner',
          'transition_type': transition_type,
          'page_title': page_title,
          'cassette_id': banner_id,
          'top_type': 0,
        };
        console.log(tonative_req)

        if (!(this.screenTransition(tonative_req))) {
          this.loading = false
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }
      }
      this.loading = false;
    },
    /*
    alert701() {
      var lost_token_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
      if (!(this.screenTransition(lost_token_alert_req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    }
    */
    toMOP(){
      var destination = 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/mop"
      var feature_id = 1
      var screen_id = "top"
      var transition_type = 2
      var top_type = 1
      var cassette_id = 1
      var transition_info = "mop"
      var page_title = "モバイルオーダー"

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    // NEW_DEV-1831 cyber start
    inArray(search,array){
        for(var i in array){
            if(array[i]==search){
                return true;
            }
        }
        return false;
    },
    async getIsStartUp(isStartUp){
      this.isStartUp = isStartUp
    }
    // NEW_DEV-1831 cyber end
  }
}
</script>

<style scoped>
.top-a {
  width: 375px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0;
  font-family: "游ゴシック体";
}

.wrap::before {
  background: -moz-linear-gradient(-58deg, #CEE6FF, #F8CFF5);
  background: -webkit-linear-gradient(-58deg, #CEE6FF, #F8CFF5);
  background: linear-gradient(148deg, #CEE6FF, #F8CFF5);
}

.logo {
    width: 100%;
}

.body {
  padding: 0 0 20px 0;
  overflow-y: auto;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;

}
.body::-webkit-scrollbar {
  display:none;
}
.carouselCtrl {
  margin: 9px 0 0 0;
}
.carouselCtrl button {
  margin: 0 0 0 5px;
  color: #9D9D9D;
  text-shadow: 0 0 4px #0000004D;
}
.carouselCtrl .active {
  color: var(--main_color) !important;
}
.card {
  width: 356px;
  height: 180px;
  margin: 20px 10px 0;
  color: #333333;
  border: 0 !important;
}
.cardTitle {
  display: block;
  margin: 18px 16px;
  width: 146px;
  height: 12px;
  font: bold 10px 'Roboto';
}
.cardDescription {
  display: block;
  margin: 20px 16px;
  width: 146px;
  font: bold 14px '游ゴシック体';
}
.cardButton {
  position: absolute;
  right: 11px;
  bottom: 11px;
  padding: 0 18px !important;
  font: normal 12px 'Roboto';
  border: 2px solid #FFFFFF;
  background-color: #FF00B1;
}
.mop905020 {
  background:url("~@/assets/mop_905020_top_a.jpg") center center / cover no-repeat;
  border-radius: 15px !important;
}
</style>
